export const getIncidencesByProcessIdInitialState = {
	data: null,
	error: null,
	errorShow: false,
	loading: false,
};
